import {
  Datagrid,
  DateField,
  EditButton,
  Filter,
  List,
  Pagination,
  PaginationProps,
  ShowButton,
  TextField,
  TextInput,
} from "react-admin"

import appConfig from "../../../config/app.config"

const PostFilters = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="label" alwaysOn />
    </Filter>
  )
}

const TagPagination = (props: PaginationProps) => (
  <Pagination rowsPerPageOptions={appConfig.paginationOptions} {...props} />
)

export const TagsList = () => (
  <List
    perPage={appConfig.paginationOptions[0]}
    filters={<PostFilters />}
    exporter={false}
    sort={{ field: "label", order: "ASC" }}
    pagination={<TagPagination />}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField source="label" />
      <TextField source="color" />
      <DateField source="created_at" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
)
